
import React, { useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";

import styles from "./SwappingStation.module.scss";
import Master from "screen/Master";
import EnergyComponent from "./EnergyComponent";
import EnergyComponentSwap from "./EnergyComponentSwap";
import EnergyComponentsLine from "./EnergyComponentsLine";
import TableAndSearch from "components/common/TableAndSearch";
import Button from "@material-ui/core/Button";
import Swapping from "../echarts/Swapping";
import LocalStorageService from "services/tokenlocalstorage.service";
import { getRequest, postRequest } from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";

let multiselectArray = [];
function SwapingStation(props) {
  const filterInitialValue = {
    siteId: "",
    chargerId: "",
    state: "",
    stateId: "",
    city: "",
    cityId: "",
    zoneId: "",
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    time: "HOUR_24",
  };

  const [filterData, setChargerMultiSelecct] = useState(multiselectArray);
  const [filter, setFilter] = useState(filterInitialValue);
  const [selectTime, setSelectTime] = useState("HOUR_24");
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [swapStationFault, setSwapStationFault] = useState([]);
  // const [swapData, setSwapData] = useEffect([]);
  // const [sessionData, setSessionData] = useState([]);
  // const [swapInfo, setSwapInfo] = useState([]);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          // alert("You clicked outside of me!");
        } else {
          setOpen(true);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [open, setOpen] = React.useState(false);

  const getSites = useCallback(async () => {
    await getRequestInAssets("bss/site/siteList")
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSites();
  }, []);

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getFaultData = useCallback(async (filter) => {
    await postRequest("bss/dashboard/swapStationFaultGraph", {
      siteId: filter.siteId,
      stateId: filter.stateId,
      cityId: filter.cityId,
      zoneId: filter.zoneId,
      timeFilterEnum: filter.time,
    })
      .then((res) => {
        if (res && res?.data) {
          setSwapStationFault(res?.data);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  // const getSwapData = useCallback( async (filter)=>{
  //   await postRequest('bss/dashboard/swapStationFaultGraph', {

  //       siteId: filter.siteId,
  //       stateId: filter.stateId,
  //       cityId: filter.cityId,
  //       zoneId: filter.zoneId,
  //       timeFilterEnum: filter.time

  //   }).then((res)=>{
  //     console.log('+++++++++||++++++++++', res)
  //     if(res && res?.data){
  //       setSwapData(res?.data)
  //     }
  //   }).catch((err)=>{
  //     console.log('Error', err)
  //   })
  // }, []);

  // const getSessionData = useCallback( async (filter)=>{
  //   await postRequest('bss/dashboard/swapStationFaultGraph', {

  //       siteId: filter.siteId,
  //       stateId: filter.stateId,
  //       cityId: filter.cityId,
  //       zoneId: filter.zoneId,
  //       timeFilterEnum: filter.time

  //   }).then((res)=>{
  //     console.log('+++++++++||++++++++++', res)
  //     if(res && res?.data){
  //       setSessionData(res?.data)
  //     }
  //   }).catch((err)=>{
  //     console.log('Error', err)
  //   })
  // }, []);

  // <<<<<<<<<<<<<<-------------------------------------API INTEGRATION FOR THE GRAPHS----------------------------------------------------->>>>>>>>>>>>>>>>>

  // const getSwapINfo = useCallback( async (filter)=>{
  //   await postRequest('bss/dashboard/swapStationFaultGraph', {

  //       siteId: filter.siteId,
  //       stateId: filter.stateId,
  //       cityId: filter.cityId,
  //       zoneId: filter.zoneId,
  //       timeFilterEnum: filter.time

  //   }).then((res)=>{
  //     console.log('+++++++++||++++++++++', res)
  //     if(res && res?.data){
  //       setSwapInfo(res?.data)
  //     }
  //   }).catch((err)=>{
  //     console.log('Error', err)
  //   })
  // }, []);

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
      filter.zoneId = headerFilterObj.zoneId;
    }
    getFaultData(filter);
    // getSwapData(filter);
    // getSessionData(filter);
    // getSwapInfo(filter);
  },[]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2628000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7884000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      value !=="" && getChargers(event.target.value);
    }
  };

  const handleClick = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        filter.siteId = filterInitialValue.siteId;
        filter.chargerId = filterInitialValue.chargerId;
        filter.time = filterInitialValue.time;
        setSelectTimeValue(filterInitialValue.time);
        setChargerList([])
      } else {
        setSelectTimeValue(selectTime);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  // const [open, setOpen] = React.useState(false);
  const [droppedFilter, setDroppedFilter] = useState(false);

  const columns = React.useMemo(() => [
    {
      Header: "Driver Name",
      accessor: "driverName",
    },
    {
      Header: "Vehicle",
      accessor: "vehicle",
    },
    {
      Header: "Swap Station Name",
      accessor: "swapStationName",
    },
    {
      Header: "Discharged Battery SOC",
      accessor: "dischargeBatterySOC",
    },
    {
      Header: "Swapped Battery SOC",
      accessor: "swappedBatterySOC",
    },
    {
      Header: "Energy Dispatched",
      accessor: "energyDispatched",
    },
    {
      Header: "Revenue",
      accessor: "revenue",
    },
    {
      Header: "Swap Time",
      accessor: "swapTime",
    },
  ]);

  var data = [
    {
      driverName: "Jhon Doe",
      vehicle: "DL 12C 1234",
      swapStationName: "Sec 62",
      dischargeBatterySOC: " 23 kWh",
      swappedBatterySOC: "34 kWh",
      energyDispatched: "60 kWh",
      revenue: "120 INR",
      swapTime: "2022-08-04 13:05",
    },
    {
      driverName: "Jhon Doe",
      vehicle: "DL 12C 1234",
      swapStationName: "Sec 62",
      dischargeBatterySOC: " 23 kWh",
      swappedBatterySOC: "34 kWh",
      energyDispatched: "60 kWh",
      revenue: "120 INR",
      swapTime: "2022-08-04 13:05",
    },
    {
      driverName: "Jhon Doe",
      vehicle: "DL 12C 1234",
      swapStationName: "Sec 62",
      dischargeBatterySOC: " 23 kWh",
      swappedBatterySOC: "34 kWh",
      energyDispatched: "60 kWh",
      revenue: "120 INR",
      swapTime: "2022-08-04 13:05",
    },
  ];

  var searchByKey = () => {};

  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Swapping"}
      </h2>

      <div className={cn(styles.block8, styles.block8_layout)}>
        <div className={cn(styles.block8_item)}>
          <div className={cn(styles.block23, styles.block23_layout)}>
            <div className={cn(styles.box10, styles.box10_layout)} />
            <div className={cn(styles.box11, styles.box11_layout)}>
              <>
                <img
                  src={require("assets/total_batteries_icon.png").default}
                  style={{
                    marginLeft: "7px",
                    marginTop: "6px",
                    cursor: "pointer",
                  }}
                />
              </>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer)} />
        <div className={cn(styles.block8_item1)}>
          <div className={cn(styles.block21, styles.block21_layout)}>
            <div className={cn(styles.block22, styles.block22_layout)}>
              <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {"Total Count"}
              </h3>
            </div>

            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout
              )}
            >
              {"50"}
            </div>
            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout1
              )}
            >
              {""}
            </div>
          </div>
        </div>
      </div>

      <div
        ref={wrapperRef}
        className={cn(styles.block1, styles.block1_layout)}
        style={{ cursor: "pointer" }}
        onClick={() => setDroppedFilter(!droppedFilter)}
      >
        <div className={cn(styles.block2, styles.block2_layout)}>
          <div className={cn(styles.block2_item)}>
            <div className={cn(styles.block3, styles.block3_layout)}>
              <div
                style={{
                  "--src": `url(${require("assets/filterblack.png").default})`,
                }}
                className={cn(styles.image1, styles.image1_layout)}
              />
            </div>
          </div>

          <div className={cn(styles.block2_spacer)} />

          <div className={cn(styles.text_body, styles.text_body_layout)}>
            {"Filters"}
          </div>
          {open && (
            <div id="filter" open={open}>
              <div
                style={{ cursor: "pointer" }}
                className={cn(
                  styles.status1_block,
                  styles.status1_block_layout
                )}
              >
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="time"
                    id="time"
                    onChange={handleChange}
                    value={filter.time}
                  >
                    <option value="-1" disabled>Select Time Period</option>
                    <option value="HOUR_24" selected>
                      Last 24 hours
                    </option>
                    <option value="HOUR_12">Last 12 hours</option>
                    <option value="WEEK">Last 1 week</option>
                    <option value="WEEK_2">Last 2 weeks</option>
                    <option value="MONTH">Last 1 month</option>
                    <option value="MONTH_3">Last 3 months</option>
                  </select>
                </div>
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="siteId"
                    id="siteId"
                    onChange={handleChange}
                    value={filter.siteId}
                  >
                    <option value="-1" selected>
                      Select Site
                    </option>
                    {sitesList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="chargerId"
                    id="chargerId"
                    onChange={handleChange}
                    value={filter.chargerId}
                  >
                    <option value="" disabled selected>
                      Select Swap Station
                    </option>
                    {chargerList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div>
                  <Button
                    style={{
                      background: "#E3324C",
                      color: "white",
                      margin: "15px 0px 6px 35px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("reset");
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    style={{
                      background: "#23297A",
                      color: "white",
                      margin: "15px 0px 6px 20px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("apply");
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={cn(styles.flex4, styles.flex4_layout)}>
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Swaps"}
                  <EnergyComponent />
                </pre>
              </h5>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Swaps/Session Time"}
                  <EnergyComponentSwap />
                </pre>
              </h5>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div className={cn(styles.flex4_item)}>
          <div className={cn(styles.block6, styles.block6_layout)}>
            <div className={cn(styles.block7, styles.block7_layout)}>
              <h5
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre
                  className={cn(styles.highlights)}
                  style={{ width: "auto" }}
                >
                  {"Fault"}
                  <EnergyComponentsLine />
                </pre>
              </h5>
            </div>
          </div>
        </div>
      </div>

      <hr className={cn(styles.line, styles.line_layout)} />
      <TableAndSearch
        searchOpts={{
          onSearch: searchByKey,
          placeholder: "Search by Swap Station",
          filter: true,
        }}
        columns={columns}
        data={data}
        // onPaginationateHandle =
      />
    </>
  );
}

export default function SwappingStationView(props) {
  return (
    <>
      <Master opts={props} screen={SwapingStation} showStatus={false} />
    </>
  );
}

SwappingStationView.inStorybook = true;
